<template>
  <v-row class="align-center">
    <div class="d-flex flex-row pa-4" style="width: 100%; gap: 16px">
      <v-text-field
        v-model="localSearch"
        density="compact"
        prepend-inner-icon="mdi-magnify"
        :label="searchLabel"
        hide-details
        clearable
        variant="solo"
        @update:model-value="$emit('update:search', localSearch)"
      />
      <v-btn color="primary" @click="dialog = true" style="height: 48px">
        <v-icon class="mr-2">mdi-filter-variant</v-icon>
        <span>Filter</span>
        <v-chip
          v-if="appliedFilterCount"
          variant="flat"
          size="small"
          color="secondary"
          class="ml-2"
        >
          {{ appliedFilterCount }}
        </v-chip>
      </v-btn>
      <v-btn
        v-if="showBookingExport"
        color="secondary"
        style="height: 48px; color: black"
        @click="exportDialog = true"
      >
        <v-icon class="mr-2">mdi-file-export</v-icon>
        <span>Export</span>
      </v-btn>
    </div>
    <v-row v-if="appliedFilters.length" class="pa-4 mx-0">
      <v-chip
        v-for="(chip, index) in appliedFilters"
        :key="chip.label + ':' + index"
        variant="flat"
        closable
        class="ma-1 bg-secondary"
        @click:close="() => removeAppliedFilterFn(chip)"
      >
        {{ chip.label }}
      </v-chip>
      <v-btn class="ml-1" color="#ff4d4f" variant="text" @click="clearAll">
        Filter zurücksetzen
      </v-btn>
    </v-row>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6 ml-2">{{ dialogTitle }}</span>
          <v-btn icon variant="text" @click="dialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <slot name="content" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="resetPending">Abbrechen</v-btn>
          <v-btn class="mr-2" color="primary" variant="flat" @click="applyFilters"> Filter Anwenden </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog for booking export -->
    <v-dialog v-if="showBookingExport" v-model="exportDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6 pl-6 pt-4">Export Buchungen</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-radio-group density="comfortable" v-model="exportFormat" inline hide-details>
            <v-radio label="CSV" value="csv"></v-radio>
            <v-radio class="ml-3" label="Excel" value="excel"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="exportDialog = false">Abbrechen</v-btn>
          <v-btn class="mr-2" variant="elevated" color="primary" @click="handleExport">Export</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    appliedFilters: { type: Array, default: () => [] },
    applyFiltersFn: { type: Function, required: true },
    resetPendingFn: { type: Function, required: true },
    clearAllFn: { type: Function, required: true },
    removeAppliedFilterFn: { type: Function, required: true },
    handleExportFn: Function,
    showBookingExport: Boolean,
    searchLabel: String,
    dialogTitle: String,
  },
  data() {
    return {
      dialog: false,
      localSearch: "",
      exportDialog: false,
      exportFormat: "csv",
    };
  },
  computed: {
    computedAppliedFilters() {
      return this.appliedFilters;
    },
    appliedFilterCount() {
      return this.appliedFilters.length;
    },
  },
  methods: {
    handleExport() {
      this.handleExportFn(this.exportFormat);
      this.exportFormat = "csv";
      this.exportDialog = false;
    },
    applyFilters() {
      this.applyFiltersFn();
      this.dialog = false;
    },
    resetPending() {
      this.resetPendingFn();
      this.dialog = false;
    },
    clearAll() {
      this.clearAllFn();
    },
  },
};
</script>
